import { Button, Modal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import {
  useDashboardMutations,
  useDashboardUsers,
} from "MyDashboards/api/useDashboards.hook";
import { DashboardMember } from "MyDashboards/state/editorTypes";
import useDashboardStore from "MyDashboards/state/useDashboardStore";
import { Dashboard } from "MyDashboards/types/api";
import _ from "lodash";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Else, If } from "react-if";
import { ReactComponent as BrokenLinkIcon } from "../../assets/broken-link_icon.svg";
import { ReactComponent as ShareIcon } from "../../assets/share_icon_white.svg";
import UsersSelection from "./UsersSelection";
import { useShareModalStyles } from "./themes";

const NotShared = () => {
  const { t } = useTranslation();
  return (
    <div className="notShared">
      <BrokenLinkIcon />
      <span>{t("Dashboard not shared")}</span>
    </div>
  );
};

interface ShareModalProps {
  open: boolean;
  onClose: VoidFunction;
  dashboard: Dashboard;
}

const ShareModal: FunctionComponent<ShareModalProps> = (props) => {
  const { t } = useTranslation();
  const ctx = useAppContext();
  const classes = useShareModalStyles(ctx.rtl)();
  const updateDashboard = useDashboardMutations();
  const [existingSharedWithUsers, setExistingSharedWithUsers] = useState<
    DashboardMember[]
  >([]);
  const dashboardsState = useDashboardStore();
  const { data: allUsers, isLoading } = useDashboardUsers();
  const [sharedWithUsers, setSharedWithUsers] = useState<DashboardMember[]>([]);
  React.useEffect(() => {
    if (!isLoading) {
      const ids = props.dashboard.usersSharedWith.map((u) => u.id);
      console.log("Shared IDS ", props.dashboard, ids, allUsers);
      console.log(
        "Shared list ",
        allUsers?.filter((u) => ids.includes(u.id))
      );
      const initialUsers = allUsers?.filter((u) => ids.includes(u.id)) || [];
      setExistingSharedWithUsers(initialUsers);
      setSharedWithUsers(initialUsers);
    }
  }, [isLoading, allUsers, props.dashboard]);
  const [isSharingEnabled, setIsSharingEnabled] = useState(
    props.dashboard.usersSharedWith.length > 0
  );
  const onShare = React.useCallback(() => {
    dashboardsState.updateDashboardSharing(
      props.dashboard._id,
      !isSharingEnabled ? [] : sharedWithUsers.map((u) => ({ id: u.id })),
      existingSharedWithUsers.map((u) => u.id)
    );
    /*
    updateDashboard.share.mutate({
      id: props.dashboard._id,
      usersSharedWith: !isSharingEnabled ? [] : sharedWithUsers.map(u => ({ id: u.id }))
    });
    */
    props.onClose();
  }, [sharedWithUsers, isSharingEnabled]);

  if (isLoading || !allUsers) {
    return null;
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        style={{ zIndex: 99999 }}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <div className={classes.body}>
            <div className="title">
              <div className="icon">
                <div className="bg">
                  <ShareIcon />
                </div>
              </div>
              <div className="titleText">
                {t("Share for")} “{props.dashboard.name}”
              </div>
              <div className="closeIcon" aria-hidden onClick={props.onClose}>
                <CloseIcon />
              </div>
            </div>

            <div className="separator" />

            <div className="content">
              <If condition={isSharingEnabled}>
                <UsersSelection
                  setSelectedItems={(_, value) => {
                    setSharedWithUsers(value);
                  }}
                  selectedItems={sharedWithUsers}
                  onRemoveMember={(member) => {
                    setSharedWithUsers((list) => {
                      return list.filter((item) => item.id !== member.id);
                    });
                  }}
                  onSelectMember={(member) => {
                    setSharedWithUsers((list) => {
                      return _.uniqBy<DashboardMember>(
                        [...list, { ...member }],
                        (item) => item.id
                      );
                    });
                  }}
                  onSelectAll={() => {
                    setSharedWithUsers([...allUsers]);
                  }}
                  onRemoveAll={() => {
                    setSharedWithUsers([]);
                  }}
                  allItems={allUsers || []}
                  columnOneTitle={t("all users")}
                  columnTwoTitle={t("shares with")}
                />
                <Else>
                  <NotShared />
                </Else>
              </If>
            </div>
            <div className="separator" />
            <div className="actions">
              <Button
                className="enableShareBtn"
                onClick={() => setIsSharingEnabled(!isSharingEnabled)}
                aria-hidden
              >
                {isSharingEnabled ? t("buttons.Disable") : t("buttons.Enable")} {t("buttons.Sharing")}
              </Button>
              <Button className="cancelBtn" onClick={props.onClose} aria-hidden>
                {t("buttons.Cancel")}
              </Button>
              <Button className="shareBtn" onClick={onShare}>
                {t("buttons.Share")}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ShareModal;
